import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { FAILURE_EVENTS, REQUEST_EVENTS, SUCCESS_EVENTS } from 'src/store/event/actions';

/* Events */
export function eventsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENTS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
